/* eslint-disable */
import * as types from './mutation-types';

export default {

  [types.SET_LIST_PRODUCT](state, { list }) {
    state.listProducts = list;
  },
  [types.SET_LIST_INVENTAIRE_HISTORY](state, { list }) {
    state.listInventaireProducts = list;
  },
  [types.SET_INVENTAIRE_HEAD](state, { inventaireHead }) {
    state.inventaireHead = inventaireHead;
  },
  [types.SET_LIST_PRODUCT_AVERAGE_QTY](state, { list }) {
    state.listInventaireProductsAverageQty = list;
  },
};
